import { Controller } from "@hotwired/stimulus"

export default class ModalController extends Controller {
  static targets = ["modal", "modalWrapper"]
  static values = { auto: Boolean }

  connect() {
    this.hasModal = this.hasModalTarget && this.hasModalWrapperTarget
    if (this.autoValue) {
      this.show()
    }
  }

  disconnect() {
    if (this.hasModal) {
      this.hide()
    }
  }

  hide() {
    this.modalTarget.close()
    this.modalWrapperTarget.classList.add("hidden")

    const backdrop = document.querySelector(".backdrop")
    backdrop.classList.remove("show")
  }

  // ปิดเมื่อแตะฉากหลัง (นอกตัว dialog) — ใช้กับ bottom sheet
  hideOnBackdrop(event) {
    if (event.target === this.modalWrapperTarget) {
      this.hide()
    }
  }

  show() {
    if (this.hasModal) {
      this.modalTarget.show()
      this.modalWrapperTarget.classList.remove("hidden")
      
      const backdrop = document.querySelector(".backdrop")
      backdrop.classList.add("show")
    }
  }
}